
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signin/find/password",
      function () {
        return require("private-next-pages/signin/find/password/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signin/find/password"])
      });
    }
  